import { useState } from 'react';
import { IconArrowRight, IconLock } from '@tabler/icons-react';
import { RewardSummary } from '@entities/game-resource';

import type { CollectionPack } from '@shared/api';
import { categories, isCategoryEnabled } from '@shared/config/categories';
import { formatQuantity } from '@shared/lib/format';
import { apiImageUrl } from '@shared/lib/media/image-url';
import { LinkButton } from '@shared/ui/button';
import { DifficultyMeter } from '@shared/ui/difficulty-meter';
import { getCollectionRewards } from '../model/collection-rewards';
import classes from './collection-card.module.css';

export const CollectionCard = ({ pack }: { pack: CollectionPack }) => {
  const [failedImage, setFailedImage] = useState<string | null>(null);
  const category = categories.find(({ id }) => isCategoryEnabled(pack.kind, [id]));
  const cover = pack.imageUrl && failedImage !== pack.imageUrl ? apiImageUrl(pack.imageUrl) : null;
  const locked = pack.accessSource === 'locked' && !pack.isFree;

  return (
    <article className={classes.card} data-category={category?.id} aria-labelledby={`collection-${pack.id}`}>
      <div className={classes.cover} data-fallback={!cover || undefined}>
        <img
          src={cover || category?.image || '/collections-illustration.webp'}
          alt=""
          loading="lazy"
          onError={cover ? () => setFailedImage(pack.imageUrl!) : undefined}
        />
        {category && <span className={classes.category}>{category.label}</span>}
      </div>
      <div className={classes.content}>
        <h2 id={`collection-${pack.id}`}>{pack.name}</h2>
        <div className={classes.meta}>
          {pack.difficulty !== undefined && <DifficultyMeter value={pack.difficulty} label="Сложность подборки" />}
          <span>{formatQuantity(pack.questionIds.length, ['вопрос', 'вопроса', 'вопросов'])}</span>
        </div>
        <div className={classes.rewards} aria-label="Награды за первое прохождение">
          <span>За первое прохождение</span>
          <RewardSummary rewards={getCollectionRewards(pack)} maximum />
        </div>
        <div className={classes.footer}>
          <span className={classes.access}>
            {locked && <IconLock size={16} aria-hidden="true" />}
            {pack.isFree || pack.accessSource === 'free' ? (
              'Бесплатно'
            ) : locked ? (
              <>
                <img src="/uznabuck.webp" alt="Монеты" />
                {pack.price.toLocaleString('ru-RU')}
              </>
            ) : (
              'Доступ открыт'
            )}
          </span>
          <LinkButton
            to="/play/collections"
            search={{ packId: pack.id }}
            variant="game"
            rightSection={<IconArrowRight size={19} aria-hidden="true" />}
          >
            {locked ? 'Открыть' : 'Играть'}
          </LinkButton>
        </div>
      </div>
    </article>
  );
};
